import type { FaireProductEntity } from "../../entity_types/product";

export const p_s8u5bw7pt9: FaireProductEntity = {
  token: "p_s8u5bw7pt9",
  type: "product",
  name: "Mahjong Essentials Notepad – 5x7 | 50 Sheets | Giftable Game",
  brandToken: "b_afmsxhpte4",
  brandName: "Thirteenwinks",
  imageUrl:
    "https://cdn.faire.com/fastly/a0d704a488dee2d9aa9f1b77c87675cb9ed1709b7b7954a8974abeccdb93ed0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dfb9b0b3c76ebdb4db15d130f12910d5215faeb61eda82adba5cb76bde4529c0.jpeg",
    "https://cdn.faire.com/fastly/346fb2692c113edca061ccd83af7858326613305996db8a8114e4cdc2b6cd2e7.jpeg",
    "https://cdn.faire.com/fastly/c2b365bd4e39790557e5eb087c12da6046e1d2ff87e0a4532f6d985f249ce8a7.jpeg",
    "https://cdn.faire.com/fastly/f775bfd0ae4d2cd3a52f3759290f63959ef68f8e98a1c9553ade97f0deda274b.jpeg",
  ],
  priceDollars: 6,
  description:
    "Bring a little flair to mahjong night with this illustrated Mahjong Essentials Notepad — designed for stylish score-keeping, hosting notes, or everyday to-do lists.Featuring a playful border of mahjong tiles, racks, dice, score cards, lamps, and cocktail cheers, this notepad is perfect for customers who love game night, hosting, and classic tile traditions.\n\nProduct Details:\n\nSize: 5” x 7”\n50 tear-off sheets\nFull-color illustrated design\nThick, smooth writing paper\nCardboard backing\nIndividually packaged in a clear sleeve\nDesigned in-house and professionally printed",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:50.713Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
